import Classnames from 'classnames'
import React, { useRef, useEffect, useState, createRef } from 'react'
import { useRecoilState, useRecoilValue } from 'recoil'
import {
  isBuilder,
  screen,
  screenOpen,
  editSectionId,
  editSectionWrapperId,
} from '@/store/builder/store'

import AudioPlayer from 'react-h5-audio-player'
import Title from '@/components/onepager/sections/Title'

function VideoSection({ id, contentID, sectionData, wrapperId }) {
  const isBuilderApp = useRecoilValue(isBuilder)
  const [getSreen, setScreen] = useRecoilState(screen)
  const [getScreenOpen, setScreenOpen] = useRecoilState(screenOpen)
  const [getEditSectionId, setEditSectionId] = useRecoilState(editSectionId)
  const [getEditSectionWrapperId, setEditSectionWrapperId] =
    useRecoilState(editSectionWrapperId)

  let theAudioPlayer = createRef()

  useEffect(() => {
    if (theAudioPlayer?.current?.audio.current) {
      theAudioPlayer.current.audio.current.pause()
    }
  }, [sectionData])

  return (
    <div className={Classnames('h-full flex flex-col ', {})}>
      <div
        className={Classnames('audioSectionWrapper group h-full ', {
          'm-5': sectionData.data.size == 'padding',
          'm-5 audioSectionPaddingRounded':
            sectionData.data.size == 'paddingrounded',
        })}
      >
        {isBuilderApp && (
          <div className="absolute w-full h-full opacity-0 group-hover:opacity-100 bg-black bg-opacity-50 flex flex-col justify-center items-center z-20	">
            <div
              onClick={() => {
                setScreen('editsection')
                setScreenOpen(true)
                setEditSectionId(id)
                setEditSectionWrapperId(wrapperId)
              }}
              className="bg-white rounded text-black font-bold py-2 px-3 cursor-pointer hover:bg-black hover:text-white"
            >
              Edit Section
            </div>
          </div>
        )}
        {sectionData.data.audio_url && (
          <>
            <div className="boxTitleBlock w-full ">
              {sectionData.title && (
                <h2 className="titleText font-bold leading-none mb-2">
                  {sectionData.title}
                </h2>
              )}
              {sectionData.prompt && (
                <h4 className="promptText">{sectionData.prompt}</h4>
              )}
            </div>
            <div className="boxBody z-10">
              <AudioPlayer
                ref={theAudioPlayer}
                src={sectionData.data.audio_url}
                onPlay={e => console.log('onPlay')}
              />
            </div>
          </>
        )}
      </div>
      {!sectionData.data.audio_url && (
        <div className="absolute w-full h-full top-0 left-0 flex flex-col justify-center items-center">
          <div className="opacity-40">No Audio Set Yet...</div>
        </div>
      )}
    </div>
  )
}

export default VideoSection
